export default {
  appId: 'YOUR_APP_ID',
  secretApp: 'YOUR_SECRET_APP',
};
